import React from 'react';
import FormConfirm from '../../components/Forms/FormConfirm';
import FormUser from '../../components/Forms/FormUser';
import Modal from '../../components/Modal';
import { deleteAccount, renewPassword } from '../../utils/httpRequest';
import { motiveForm } from '../../utils/formVerifications';
import { Animation } from '../../assets/global/globalStyles';
import { httpRequestAccount } from '../../store/account';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';

export default function CreateUser() {
  const {
    account: { data: account },
  } = useSelector((state) => state);
  const [httpMethod, setHttpMethod] = React.useState(false);
  const [toggle, setToggle] = React.useState(false);
  const formRef = React.useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  const verifyHttpType = React.useCallback(
    (typeHttp) => {
      setHttpMethod(typeHttp);
      setToggle(!toggle);
    },
    [toggle],
  );

  const handleSubmit = async (data) => {
    if (!id) formRef.current.setErrors({});
    const { payload, error } = await motiveForm(data);
    if (error) return formRef.current.setErrors(error);
    if (payload) {
      if (id) {
        const request = {
          email: account?.email,
          reason: payload.reason,
        };
        if (httpMethod === 'unlock' || httpMethod === 'reset') {
          const { success } = await dispatch(
            httpRequestAccount(renewPassword(request)),
          );
          if (success) navigate(-1);
        } else {
          const { success } = await dispatch(
            httpRequestAccount(deleteAccount(request)),
          );
          if (success) navigate(-1);
        }
        setToggle(!toggle);
      }
    }
  };

  const textModal = () => {
    const obj = {
      reset: 'resetar senha do',
      unlock: 'desbloquear a',
      delete: 'deletar a',
    };

    return obj[httpMethod] || obj.delete;
  };

  return (
    <>
      <Animation>
        <FormUser openModal={verifyHttpType} />
      </Animation>
      <Modal open={toggle} openModal={() => setToggle(!toggle)}>
        <FormConfirm
          handleSubmit={handleSubmit}
          formRef={formRef}
          subTitle={`Coloque o motivo para ${textModal()} conta: *`}
          openModal={() => setToggle(!toggle)}
        />
      </Modal>
    </>
  );
}
